<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>Planos</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar os planos cadastrados.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="listaPlano" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let plano">{{ plano.id }}</td>
            </ng-container>
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef>Plano</th>
              <td mat-cell *matCellDef="let plano">{{ plano.nome }}</td>
            </ng-container>
            <ng-container matColumnDef="segmento">
              <th mat-header-cell *matHeaderCellDef>Segmento</th>
              <td mat-cell *matCellDef="let plano">{{ plano.segmentoNome }}</td>
            </ng-container>
            <ng-container matColumnDef="valorBase">
              <th mat-header-cell *matHeaderCellDef>Valor Base</th>
              <td mat-cell *matCellDef="let plano">{{ plano.valorBase | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="taxaAdesao">
              <th mat-header-cell *matHeaderCellDef>Taxa de Adesão</th>
              <td mat-cell *matCellDef="let plano">{{ plano.taxaAdesao | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="situacao">
              <th mat-header-cell *matHeaderCellDef>Situação</th>
              <td mat-cell *matCellDef="let plano">{{ plano.situacao ? 'Ativo' : 'Inativo' }}</td>
            </ng-container>
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let plano" (click)="$event.stopPropagation()">
                <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(plano.id)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" matTooltip="Excluir" (click)="openDialog(plano.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>

          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
          </mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
